export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname);

  if (!current || !url) {
    return false
  }
  const urlParts = url.split('/');
  const currentParts = current.split('/');

  if (currentParts[1].toLowerCase() == urlParts[1].toLowerCase() || current === url || current.startsWith(url)) {

    return currentParts[1].toLowerCase() === urlParts[1].toLowerCase();
  }

  return false
}
